export default __webpack_public_path__ + "static/media/Games.711f0580.png";